import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
  Page,
  ProductGroupDetailDto,
  RegisterProductGroupSearchParams
} from '../../generated-model/model';
import {environment} from '../../environments/environment';
import {IgnoreNullHttpParams} from '../shared/Ignore-null-http-params';
import {PageRequest} from '../app.constants';

@Injectable({providedIn: "root"})
export class ProductDetailRest {

  http = inject(HttpClient)

  public search(params: RegisterProductGroupSearchParams, pageRequest: PageRequest) {
    let httpParams = IgnoreNullHttpParams.fromObject({
      ...params,
      ...pageRequest
    }).toHttpParam()
    return this.http.get<Page<ProductGroupDetailDto>>(`${environment.serverUrl}/api/product-group-details`, {
      params: httpParams
    })
  }

  public findProductDetails(term: string, productGroupId: number) {
    let httpParams = IgnoreNullHttpParams.fromObject({
      term: term,
      productGroupId: productGroupId
    }).toHttpParam()
    return this.http.get<ProductGroupDetailDto[]>(`${environment.serverUrl}/api/product-group-details/product-details`, {
      params: httpParams
    })
  }

  public save(productGroupDetailDto: ProductGroupDetailDto) {
    return this.http.post<ProductGroupDetailDto>(`${environment.serverUrl}/api/product-group-details/save`, productGroupDetailDto)
  }

  public delete(id: number) {
    return this.http.delete(`${environment.serverUrl}/api/product-group-details/delete/${id}`)
  }

  public searchAutocomplete(term: string, id: string,isProduct: boolean) {
    let param = IgnoreNullHttpParams.fromObject({
      term: term,
      qrTraceId: id,
      isProduct: isProduct
    }).toHttpParam()
    return this.http.get<ProductGroupDetailDto[]>(`${environment.serverUrl}/api/product-group-details/autocomplete`, {params: param})
  }

  public downloadTemplate() {
    return this.http.get(`${environment.serverUrl}/api/excel/download`, {
      responseType: 'blob',
    });
  }

  public import(file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(`${environment.serverUrl}/api/excel/import`, formData, {
    });
  }


  public existingProduct(productGroupDetailDto: ProductGroupDetailDto){
    const params = IgnoreNullHttpParams.fromObject({...productGroupDetailDto})
    return this.http.get<boolean>(`${environment.serverUrl}/api/product-group-details/existing-product`, {params: params.toHttpParam()})
  }
}
